module.exports = __webpack_public_path__ + "img/ellipse.ecbd26d1.svg";